import GraphEntity from "./graphEntity";
import Field from "./field";
import Graph from "./graph";
import { ascending } from "@/util/sort";

class Type extends GraphEntity {
    constructor(type, graph) {
        super(type, graph)
    }

    getFields(currentPath = []) {
        const self = this;
        const fields = [];
        const entityTypes = currentPath.map(field => field.value.type.entityType);
        const currentPathString = Graph.getPathString(currentPath);
        let calculatedOrder = 10000000;

        self.value.fields.forEach(field => {

            const fieldObj = new Field(field, self._graph);

            if (fieldObj.isCalculated) {
                if (!field.calculatedField.typePath) {
                    if (field.type === "instance" || !!field.calculatedField.entityType || entityTypes.indexOf(field.calculatedField.entityType) !== -1) {
                        fieldObj.value.displayOrder = calculatedOrder++;
                        fields.push(fieldObj);
                    }
                } else if (field.calculatedField.typePath === currentPathString) {
                    fieldObj.value.displayOrder = calculatedOrder++;
                    fields.push(fieldObj);
                }
            } else {
                if (fieldObj.value.displayOrder === undefined || fieldObj.value.displayOrder === null) {
                    fieldObj.value.displayOrder = 0;
                }

                fields.push(fieldObj);
            }
        });

        self.value.inheritedTypes.forEach(typeName => {
            const inheritedType = self._graph.getType(typeName);
            inheritedType.value.fields.forEach(field => fields.push(new Field(field, self._graph)));
        });

        fields.sort(ascending(field => field.value.displayOrder));
        return fields;
    }

    getField(name) {
        const fields = this.getFields();
        return fields.find(f => f.value.name === name);
    }

    getFieldGroups() {
        const groups = [...this.value.fieldGroups];

        groups.sort(ascending(group => group.displayOrder));
        return groups;
    }
}

export default Type;